import blocks from '../../blocks';
import { connectedStore } from '../../store';
import getBlockIdsByElement from '../../blocks/accessors/get-block-ids-by-element';

const getUsedBlockTemplatesIdsFromElement = (element) => {
  const store = connectedStore.get();
  const state = store.getState();
  const blockList = blocks.selectors.getBlocks(state);
  const usedBlocks = getBlockIdsByElement(element);

  const usedBlockTemplatesIds = blockList.reduce((sum, block) => {
    if (usedBlocks.includes(block.id) && block.templateId) {
      sum.add(block.templateId);
    }

    return sum;
  }, new Set());

  return [...usedBlockTemplatesIds];
};

export default getUsedBlockTemplatesIdsFromElement;
